<template>
    <div>
        <span @click="search()">
            <Button type="primary" @click="modal = true" v-hasPermission="['permissionsConfigurationManagement:accountGroupConfig:account_config']">{{ $t('RIAccountGroupManagement.addAccount') }}</Button>
        </span>
        <Modal v-model="modal" :title="$t('permission_configuration_management.account.addAccount')" width="900px;" :mask-closable="false">
            <Row style="margin-bottom: 10px;">
                <Col span="4">{{ $t('RIAccountGroupManagement.area') }}:{{this.$route.query.areaType}}</Col>
                <Col>{{ $t('RIAccountGroupManagement.AZ') }}:{{this.$route.query.region}}</Col>
            </Row>
            <div slot="footer">
                <Button @click="cancel()">{{ $t('alarms.common.cancel') }}</Button>
                <Button type="primary" @click="handleSubmit()" :loading="addloading" :disabled="isDisable">{{ $t('RIAccountGroupManagement.addAccount') }}</Button>
            </div>
            <Table :no-data-text="$t('common.noData')" ref="selection" :columns="columns" :loading="loading" :data="accountData" :height="400" @on-selection-change="getSelection"></Table>
        </Modal>
    </div>
</template>

<script>
    import {getCookie} from '../../../../utils/cookieUtil.js'
    import TableAccountGroupConfig from '../account_group/TableAccountGroupConfig'

    var tableAccountGroupConfig = TableAccountGroupConfig;
    export default {
        name: 'AddAccount',
        data() {
            return {
                areaType:'',
                selection: [],
                modal: false,
                isDisable: true,
                loading: false,
                addloading:false,
                columns: [
                    {
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: this.$t('RIAccountGroupManagement.accountName'),
                        key: 'name'
                    },
                    {
                        title: this.$t('RIAccountGroupManagement.companyName'),
                        key: 'companyName'
                    },
                    {
                        title: this.$t('RIAccountGroupManagement.accountID'),
                        key: 'accountId'
                    }
                ],
                accountData: [],
                newAccountDataList:[]
            }
        },
        methods: {
            search:function(){
                this.loading=true;
                if(this.$route.query.areaType==this.$t('RIAccountGroupManagement.China')){
                    this.areaType=1;
                }else if(this.$route.query.areaType==this.$t('RIAccountGroupManagement.Overseas')){
                    this.areaType=2;
                }
                // 根据AccountId查询队列列表
                this.$api.account.queryAccountList({
                    "id":this.$route.query.id,
                    "areaType":this.areaType
                })
                .then(res => {
                    this.accountData = res.data;
                    this.loading=false;
                })
            },
            // 当前选择checkbox
            getSelection: function (selection) {
                this.selection = selection;
                // 清空数组
                this.newAccountDataList = [];
                for (var i = 0; i < this.selection.length; i++) {
                    this.newAccountDataList.push(this.selection[i].id);
                }
                // 选了数据 可以点击下一步
                if (this.newAccountDataList.length == 0) {
                    this.isDisable = true;
                } else {
                    this.isDisable = false;
                }
            },
            // 添加
            handleSubmit: function () {
                this.addloading=true;
                // 增加
                this.$api.accountGroup.createAccount({
                    "id":this.$route.query.id,
                    "areaType": this.areaType,
                    "region": this.$route.query.region,
                    "accountIds":this.newAccountDataList
                }).then(res => {
                    setTimeout(() => {
                        tableAccountGroupConfig.methods.showAll();
                        this.$Message.success(this.$t('common.addSuccess'));
                        this.accountData=[];
                        this.newAccountDataList=[];
                        this.isDisable = true;
                        this.modal = false;
                        this.addloading=false;
                    }, 1000);
                })
            },
             // 取消
            cancel: function () {
                this.isDisable = true;
                this.modal = false;
                this.accountData=[];
                this.newAccountDataList=[];
            }
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/account_group/AddAccount.vue